import { Helmet } from 'react-helmet';

/**
 * Ensures a string starts with a single leading slash.
 * Used when concatenating siteUrl + relative paths.
 */
const ensureLeadingSlash = (value = '') => (value.startsWith('/') ? value : `/${value}`);

/**
 * Removes any trailing slashes from a string.
 * Example: "https://example.com/" → "https://example.com"
 */
const removeTrailingSlash = (value = '') => value.replace(/\/+$/, '');

/**
 * Builds an absolute URL from a siteUrl and a relative path.
 * If the input is already absolute, it is returned as-is.
 */
const buildAbsoluteUrl = (siteUrl, path) => {
    if (!path) return null;
    if (path.startsWith('http')) return path;
    if (!siteUrl) return null;

    return `${siteUrl}${ensureLeadingSlash(path)}`;
};

const Seo = ({ title, description, image, url, type = 'website' }) => {
    /**
     * Public base URL for the site.
     */
    const siteUrl = removeTrailingSlash(process.env.GATSBY_SITE_URL || '');

    const absoluteUrl = buildAbsoluteUrl(siteUrl, url);
    const absoluteImagePath = buildAbsoluteUrl(siteUrl, image) || image || null;

    return (
        <Helmet>
            <meta charSet="utf-8" />
            <title>{title}</title>

            {description && <meta name="description" content={description} />}

            {absoluteUrl && <link rel="canonical" href={absoluteUrl} />}
            {absoluteUrl && <meta property="og:url" content={absoluteUrl} />}

            <meta property="og:title" content={title} />
            {description && <meta property="og:description" content={description} />}
            <meta property="og:type" content={type} />

            {absoluteImagePath && <meta property="og:image" content={absoluteImagePath} />}

            <meta name="twitter:card" content={absoluteImagePath ? 'summary_large_image' : 'summary'} />
            <meta name="twitter:title" content={title} />
            {description && <meta name="twitter:description" content={description} />}
            {absoluteImagePath && <meta name="twitter:image" content={absoluteImagePath} />}
        </Helmet>
    );
};

export default Seo;
